export default function LoadingSpinner({ size = "md", className = "" }) {
  const sizeMap = {
    sm: "w-1 h-6",     // 1px wide
    md: "w-1 h-8",     // 1px wide (default)
    lg: "w-1.5 h-12",
  };

  const barSize = sizeMap[size] ?? sizeMap.md;

  return (
    <div className={`flex items-end justify-center space-x-1 ${className}`}>
      {[0, 1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className={`bg-green-700 rounded-full ${barSize} animate-impulse`}
          style={{
            animationDelay: `${i * 0.1}s`,
          }}
        />
      ))}
    </div>
  );
}